import React from 'react'
import { Box, Grid, Typography } from '@mui/material';
import Lottie from "lottie-react";
import * as animationData from './error.json'

export const ErrorPage = () => {
  return (
    <Box sx={{display:"flex",alignItems:"center",justifyContent:"center", height:"100vh",width:1}}>
      <Grid container spacing={0} sx={{display:"flex",alignItems:"center",justifyContent:"center"}}>
        <Grid item xs={12} sm={12} md={6} sx={{display:"flex",alignItems:"center",justifyContent:"center"}}>
          <Lottie 
            animationData={animationData}
            loop
            autoplay
            style={{ height: 600, width: 600 }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <img
            src={require('../../assets/images/club-car-connect-logo.png')}
            width={200}
            height={100}
          />
          <Typography variant='h4' marginTop={5}>
           The page you are looking for doesn't exists.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
